import { getSupportChannelTypes } from '@/tools';

const state = getSupportChannelTypes().reduce((previous_value, current_value) => {
  return Object.assign(previous_value, {
    [current_value]: {},
    [`${current_value}_enum`]: {},
  });
}, {});

const mutations = {
  /**
   * 设置媒体渠道枚举值
   * @param {Object} state Vuex状态对象
   * @param {Object} payload 包含枚举值和媒体渠道的对象
   * @param {string} payload.channel 所属的媒体渠道
   * @param {Object} payload.value 枚举值数据对象
   */
  SET_CHANNEL_ENUM_DATA(state, { channel, value }) {
    state[channel] = value;
  },
  /**
   * 设置媒体渠道枚举映射值
   * @param {Object} state Vuex状态对象
   * @param {Object} payload 包含枚举映射值和媒体渠道的对象
   * @param {string} payload.channel 所属的媒体渠道
   * @param {Object} payload.value 枚举映射值数据对象
   */
  SET_CHANNEL_ENUM_MAP(state, { channel, value }) {
    state[`${channel}_enum`] = value;
  },
};

const actions = {
  /**
   * 设置枚举值
   * @param {Object} context Vuex上下文对象，包含commit、dispatch等方法
   * @param {Object} payload 包含枚举值和渠道信息的对象
   * @param {string} payload.channel 所属的媒体渠道
   * @param {Object} payload.value 枚举值数据对象
   */
  setEnumValue({ commit }, { value, channel }) {
    const enum_map = {};
    for (const key in value) {
      const options = value[key];
      enum_map[key] = {};
      for (let i = 0; i < options.length; i++) {
        const item = options[i];
        enum_map[key][item.value] = item.label;
      }
    }
    commit('SET_CHANNEL_ENUM_DATA', { channel, value });
    commit('SET_CHANNEL_ENUM_MAP', { channel, value: enum_map });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
